/**
 * How a business category is written on screen.
 *
 * The vocabulary is keyed the way the classifier writes it - `gas_station`,
 * `meal_takeaway` - because that is what OSM and Google hand over and what
 * `places.types` has always held. A person reading a lead should not have to.
 * The key stays the value; only the label changes.
 */
export function businessTypeLabel(name: string): string {
  const words = name.replace(/_/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : name;
}

/** The same, for a lead's whole set: labelled, in the order given. */
export function businessTypeLabels(names: readonly string[]): string[] {
  return names.map(businessTypeLabel);
}
